// 申请状态

export const CHECK_STATUS = [
  {
    title: '全部',
    val: '',
  },
  {
    title: '待审核',
    val: 0,
  },
  {
    title: '已通过',
    val: 2,
  },
  {
    title: '已驳回',
    val: 3,
  },
];

// 同步状态
export const SYNC_STATUS = [
  {
    title: '全部',
    val: '',
  },
  {
    title: '未同步',
    val: 0,
  },
  {
    title: '同步成功',
    val: 2,
  },
  {
    title: '同步失败',
    val: 3,
  },
  {
    title: '已失效',
    val: 4,
  },
];
export const CHECK_STATUS_MAP = {};
export const SYNC_STATUS_MAP = {};

function transformArr2Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.val] = item.title;
  });
}
transformArr2Map(CHECK_STATUS, CHECK_STATUS_MAP);
transformArr2Map(SYNC_STATUS, SYNC_STATUS_MAP);
